import { c as _c } from "react/compiler-runtime";
type PdfThumbnailProps = {
  src: string;
};
const PdfThumbnail = t0 => {
  const $ = _c(2);
  const {
    src
  } = t0;
  let t1;
  if ($[0] !== src) {
    t1 = <div className="absolute inset-0"><iframe title="pdf" src={src} width="100%" height="100%" data-dd-privacy="mask" /></div>;
    $[0] = src;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default PdfThumbnail;